// Maps the typed failure code from the OAuth callback to copy written for the
// rep using Zeph — what happened and what they can do about it. The technical
// detail behind each code (which phase failed, Microsoft's own response body)
// lives in the API logs, not here.
const CONNECT_ERROR_COPY: Record<string, string> = {
  outlook_token_exchange_failed: 'Microsoft couldn\'t complete the sign-in. Please try again.',
  outlook_profile_lookup_failed: 'Zeph couldn\'t read your Microsoft account details. Please try again.',
  outlook_profile_incomplete: 'Zeph couldn\'t read your Microsoft account details. Please try again.',
  outlook_api_error: 'Zeph couldn\'t reach your Outlook mail. Please try again.',
  outlook_calendar_api_error: 'Zeph couldn\'t reach your Outlook calendar. Please try again.',
  oauth_state_expired: 'That took too long, so Zeph stopped the connection for safety. Please connect again.',
  invalid_state: 'That sign-in link isn\'t valid anymore. Please start the connection again.',
  access_denied: 'The connection was cancelled. You can try again whenever you\'re ready.',
}

const FALLBACK = 'Something went wrong connecting your Outlook account. Please try again.'

export function connectErrorCopy(reason: string | null): string {
  if (!reason) return FALLBACK
  return CONNECT_ERROR_COPY[reason] ?? FALLBACK
}
